var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureSub5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164155",
    transform: "translate(-1396 -6289)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9447",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1396 6289)",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 19.9a16.269 16.269 0 0 1 1.6-7.1 18.41 18.41 0 0 1 4.4-5.85l.8.85a16.369 16.369 0 0 0-4.2 5.425 15.228 15.228 0 0 0-1.5 6.675zm32.4 0a15.443 15.443 0 0 0-1.475-6.675A16.366 16.366 0 0 0 34.05 7.8l.75-.85a18.092 18.092 0 0 1 4.375 5.85 16.484 16.484 0 0 1 1.575 7.1zM9.3 37.3v-1.1h4.05V20.5a10.658 10.658 0 0 1 2.5-6.85 10.163 10.163 0 0 1 6.5-3.75V8.5a1.538 1.538 0 0 1 .45-1.175 1.907 1.907 0 0 1 2.4 0 1.538 1.538 0 0 1 .45 1.175v1.4a10.163 10.163 0 0 1 6.5 3.75 10.658 10.658 0 0 1 2.5 6.85v15.7h4.05v1.1zM24 23.65zM24 43a2.962 2.962 0 0 1-2.1-.85A2.831 2.831 0 0 1 21 40h6a2.907 2.907 0 0 1-3 3zm-9.55-6.8h19.1V20.5a9.241 9.241 0 0 0-2.775-6.75A9.176 9.176 0 0 0 24 10.95a9.2 9.2 0 0 0-6.75 2.8 9.2 9.2 0 0 0-2.8 6.75z",
    transform: "translate(1415.75 6308.1)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSub5);
export default __webpack_public_path__ + "static/media/feature-sub-5.3b95176a01e2c9dd618249b5b4af933d.svg";
export { ForwardRef as ReactComponent };